import { servicesData } from "./services";

export const siteUrl = "https://allinsolutions.com.au";
export const pages = [
  {
    path: "/",
    title: "All In Solutions | Print & Marketing Procurement Services",
    description: "Discover premium print and marketing procurement solutions. All In Solutions manages artwork, sourcing and delivery so you can focus on growing your business.",
  },
  {
    path: "/catalogue/",
    title: "Product Catalogue | All In Solutions Print & Marketing",
    description: "Browse customised print, signage, display, packaging and apparel products. All In Solutions handles artwork, sourcing and delivery for your business needs.",
  },
  ...servicesData.map(service => ({
    path: `/services/${service.slug}/`,
    title: service.slug === "it-services"
      ? "Custom IT Services | All In Solutions Australia Brisbane"
      : `${service.title.length < 12 ? "Expert " : ""}${service.title} Services | All In Solutions Australia`,
    description: `Explore ${service.title.toLowerCase()} solutions with All In Solutions. We manage artwork, sourcing and delivery to support your unique business and marketing needs.`,
  })),
];

export const organization = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "All In Solutions",
  url: `${siteUrl}/`,
  logo: `${siteUrl}/icon-512.png`,
  email: "info@allinsolutions.com.au",
  telephone: "+61451000000",
  sameAs: ["https://www.instagram.com/allinsolutionsau"],
};
